import { render, staticRenderFns } from "./SidebarFilterCustomerList.vue?vue&type=template&id=4aa98556&scoped=true"
import script from "./SidebarFilterCustomerList.vue?vue&type=script&lang=js"
export * from "./SidebarFilterCustomerList.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilterCustomerList.vue?vue&type=style&index=0&id=4aa98556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa98556",
  null
  
)

export default component.exports